import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/core/Breadcrumbs";
import { UpsertExportParameterForm } from "../../features/parameters/export-parameter/UpsertExportParameterForm";
import { AuthenticatedLayout } from "../../features/user/layouts/AuthendicatedLayout";

export const EditExportParameter = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, [id, navigate]);

  return (
    <AuthenticatedLayout>
      <Breadcrumbs />
      <UpsertExportParameterForm id={id} />
    </AuthenticatedLayout>
  );
};
